// extracted by mini-css-extract-plugin
module.exports = {"subscription_badge":"course-badges_subscription_badge__W61D8","grow-with-google-badge":"course-badges_grow-with-google-badge__8cisG"};